import { memo } from "react"
import { DTO_MaintenanceRecord, DTO_ServiceBase } from "../../../../../services/calls/types/maintenance"
import { ICON } from "../../../../../components/Icon/data"
import { useTranslation } from "react-i18next"
import Icon from "../../../../../components/Icon"

import './index.scss'
import Tooltip from "../../../../../components/Tooltip"

type Row = {
  base: DTO_ServiceBase
}

type InstanceColumn = {
  value: DTO_MaintenanceRecord
  row: Row
  openModal: (row: Row) => void
}

const InstanceColumn = memo(({ value, row, openModal = () => {} }: InstanceColumn) => {
  const { t } = useTranslation()
  
  if (!value) return null

  const typeMap = {
    overdue: {
      icon: ICON.ADD,
      iconHover: ICON.ADD,
      tooltip: t('Overdue'),
    },
    due_soon: {
      icon: ICON.ADD,
      iconHover: ICON.ADD,
      tooltip: t('Due soon'),
    },
    upcoming: {
      icon: ICON.ADD,
      iconHover: ICON.ADD,
      tooltip: t('Due soon'),
    },
    finished: {
      icon: ICON.CHECKMARK,
      iconHover: ICON.EDIT,
    }
  }

  return (
    <div className="InstanceColumn">
      <div
        className={`InstanceColumn__button ${value.status}`}
        role="button"
        tabIndex={0}
        onClick={() => openModal(row)}
      >
        <Tooltip content={<Icon icon={typeMap[value.status]?.icon} />} text={typeMap[value.status]?.tooltip} />
      </div>
    </div>
  )
})

export default InstanceColumn
